import React from 'react'
import styled from 'styled-components'
import { SwallerToast } from './SwallerToast'

const Container = styled.div`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 998;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;

  > * {
    pointer-events: all;
  }

  @media (max-width: 768px) {
    left: 50%;
    transform: translateX(-50%);
    right: auto;
    align-items: center;
  }
`

export const SwallerContainer = ({ toasts, onDismiss }) => {
  if (toasts.length === 0) return null

  return (
    <Container>
      {toasts.map((toast) => (
        <SwallerToast key={toast.id} {...toast} onDismiss={onDismiss} />
      ))}
    </Container>
  )
}
